module Meevo.Components.Controls.SmartMover {
    import Service = Model.Service;

    export class CSEServicesCollection extends ServicesCollection implements IApiCollection<Service> {
        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }
    }
}
